oyc.Popover = {
  dialogToggleBtn: '[data-popover-target]',
  dialogCloseBtn: '.js-popover-close',

  init: function () {
    this.bindEvents();
  },

  bindEvents: function () {
    var self = this;

    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest(self.dialogToggleBtn);

      if (toggleBtn) {
        e.preventDefault();
        var dialogId = toggleBtn.getAttribute('data-popover-target');
        var dialog = document.getElementById(dialogId);

        if (dialog) {
          if (dialog.open) {
            dialog.close();
          } else {
            dialog.show();
            dialog.setAttribute('data-trigger-id', toggleBtn.id || self.generateId(toggleBtn));
          }
        }
      }

      var closeBtn = e.target.closest(self.dialogCloseBtn);

      if (closeBtn) {
        e.preventDefault();
        var dialog = closeBtn.closest('dialog');
        if (dialog) {
          dialog.close();
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var openDialogs = document.querySelectorAll('dialog[open]');
        openDialogs.forEach(function (dialog) {
          dialog.close();
        });
      }

      if (e.key === 'Tab') {
        var openDialogs = document.querySelectorAll('dialog[open]');

        openDialogs.forEach(function (dialog) {
          var triggerId = dialog.getAttribute('data-trigger-id');
          var triggerBtn = triggerId ? document.getElementById(triggerId) : null;

          var focusableElements = dialog.querySelectorAll(
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
          );

          if (focusableElements.length === 0) return;

          var lastElement = focusableElements[focusableElements.length - 1];

          if (e.shiftKey) {
            if (triggerBtn && document.activeElement === triggerBtn) {
              dialog.close();
            }
          } else {
            if (document.activeElement === lastElement) {
              dialog.close();
            }
          }
        });
      }
    });
  },

  generateId: function (element) {
    var id = 'trigger-' + Date.now();
    element.id = id;
    return id;
  }
};
